import { useCallback } from 'react';

import classNames from 'classnames';

import noop from '@picsart/rc/noop';

import SvgIcon from 'components/SvgIcon';
import { ANALYTICS_NAMES } from 'templates/components/SingleTemplate/constants';

import { SOCIAL_MEDIA_TYPE_ENUM } from 'types/global';

import shareImageOnSocialMedia from './utils/shareImageOnSocialMedia';

import type { ShareButtonType } from './types';

import { useShareButtonStyles } from './styles';

const { FACEBOOK, LINKEDIN, PINTEREST, TUMBLR, TWITTER } = SOCIAL_MEDIA_TYPE_ENUM;

export const SOCIAL_MEDIA_NAMES = {
  [FACEBOOK]: 'facebook',
  [PINTEREST]: 'pinterest',
  [TWITTER]: 'twitter',
  [LINKEDIN]: 'linkedin',
  [TUMBLR]: 'tumblr',
};

const ShareButton = ({
  analyticsPageClick = noop,
  imageViewPageUrl,
  onClick = noop,
  compactMode,
  license,
  position,
  svgName,
  smType,
  label,
}: ShareButtonType) => {
  const styles = useShareButtonStyles();

  const handleShareClick = useCallback(async () => {
    const { ACTION_BUTTON } = await import('services/Analytics/templateAnalytics/config');
    const additionalInfo = {
      is_fte: license === 'fte',
    };
    if (analyticsPageClick.length >= 3) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      analyticsPageClick(ACTION_BUTTON.social_links, position, {
        social_links: SOCIAL_MEDIA_NAMES[smType],
        ...additionalInfo,
      });
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      analyticsPageClick(ACTION_BUTTON.social_links, {
        social_links: SOCIAL_MEDIA_NAMES[smType],
        ...additionalInfo,
      });
    }

    shareImageOnSocialMedia({ smType, imageViewPageUrl });
    onClick();
  }, [analyticsPageClick, smType, imageViewPageUrl, onClick, position]);

  return (
    <li
      className={classNames(styles.root, { compact: compactMode })}
      data-testid={`share_${label}_button_test_id`}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={handleShareClick}
      role="presentation"
      key={label}
      data-pulse-clickable="true"
      data-pulse-name={`${ANALYTICS_NAMES.SHERE_BUTTON}_${label}`}
    >
      <SvgIcon
        name={svgName}
        className={classNames(styles.listItemIconHolder, 'brand', { compact: compactMode })}
      />
      {!compactMode && <span className={styles.listItemTitle}>{label}</span>}
    </li>
  );
};

export default ShareButton;
